import React from 'react';
import { useFieldArray, Control } from 'react-hook-form';

interface FormFieldArrayProps {
  control: Control<any>;
  name: string;
  label?: string;
  errors?: any;
  placeholder?: string;
}

const FormFieldArray: React.FC<FormFieldArrayProps> = ({ control, name, label, errors, placeholder }) => {
  const { fields, append, remove } = useFieldArray({ control, name });
  return (
    <div>
      {label && <label className="block text-sm font-medium mb-1 text-gray-700">{label}</label>}
      {fields.map((field, index) => (
        <div key={field.id} className="flex items-center gap-2 mb-2">
          <input
            className={`w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400`}
            {...control.register(`${name}.${index}`)}
            placeholder={placeholder || ''}
          />
          <button type="button" onClick={() => remove(index)} className="btn bg-red-500 text-white px-2 py-1 rounded">Xóa</button>
        </div>
      ))}
      {errors?.[name] && typeof errors[name]?.message === 'string' && (
        <p className="text-red-500 text-xs mt-1">{errors[name]?.message}</p>
      )}
      {errors?.[name]?.root?.message && typeof errors[name]?.root?.message === 'string' && (
        <p className="text-red-500 text-xs mt-1">{errors[name]?.root?.message}</p>
      )}
      <button type="button" onClick={() => append('')} className="btn bg-green-500 text-white px-3 py-1 rounded">Thêm</button>
    </div>
  );
};

export default FormFieldArray;
